import React, { useState, useEffect } from "react";
import { View, Dimensions } from "react-native";
import Header from "../../common/Header";
import Sidebar from "../../common/Sidebar";
import TabHeader from "../../common/TabHeader";
import ServiceRequest from "../../screens/ServiceRequest";
import { CreateResponsiveStyle, DEVICE_SIZES, maxSize} from "rn-responsive-styles";
import MobileHeader from "../../common/MobileHeader";

export default function Index(props) {
  const styles = useStyles();
  const [isShowSidebar, setIsShowSidebar] = useState(false);

  return (
    <>
      <Header />
      <MobileHeader isShowSidebar={setIsShowSidebar} />
      <TabHeader />
      <View style={styles.mainContainer}>
        <View style={styles.contentWidget}>
          {!isShowSidebar && <Sidebar />}
          <ServiceRequest />
        </View>
      </View>
    </>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    mainContainer: {
      width: "100%",
      height: "100vh",
      flexDirection: "row",
      justifyContent: "center",
      paddingTop: 40,
      backgroundColor: "#f2f4f5",
      backgroundImage:
        "linear-gradient(to top, #f2f4f5, #f2f4f5 50%, #eee 50%, #333 50%);",
    },
    contentWidget: {
      maxWidth: 1200,
      width: "100%",
      flexDirection: "row",
    },
  },

  {
    [maxSize(DEVICE_SIZES.LG)]: {
    },

    [maxSize(DEVICE_SIZES.MD)]: {
    },

    [maxSize(DEVICE_SIZES.SM)]: {
      contentWidget: {
        width: "90%",
        maxWidth: "100%",
      },
    },
    [maxSize(DEVICE_SIZES.XS)]: {
      mainContainer: {
        paddingTop: 20,
        marginLeft: -5,
      },
      contentWidget: {
        width: "90%",
        maxWidth: "100%",
      },
    },
  }
);
